import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Typography, styled, Container } from "@mui/material";
import { useGetUserQuery } from '../../api/api';
import { ReactComponent as CaretCircleDown } from 'assets/icons/CaretCircleDown.svg';
import EditUserModal from "pages/UserPages/EditUserModal";
import ChangePasswordModal from "pages/UserPages/ChangePasswordModal";

const Profile = () => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [isEditingProfile, setIsEditingProfile] = useState<boolean>(false);
  const [isResettingPassword, setIsResettingPassword] = useState<boolean>(false);

  const { user, isAuthenticated, isLoading, logout } = useAuth0();
  const { data: userData } = useGetUserQuery();

  const getDisplayName = () => {
    if (userData?.first_name && userData?.last_name) {
      return `${userData.first_name} ${userData.last_name}`;
    } else if (user?.name) {
      return `${user.name}`;
    }
    return 'n/a';
  }

  const renderDropdown = () => {
    const styleText = (text) => (
      <Typography noWrap variant="body2" color={'#1A1A1A'}>
        {text}
      </Typography>
    );

    return <div className="Profile-dropdown">
      <button className="Profile-action"
              onClick={() => {
                setIsEditingProfile(true);
                setIsExpanded(false);
              }}>
        {styleText('Edit Profile')}
      </button>
      <button className="Profile-action"
              onClick={() => {
                setIsResettingPassword(true);
                setIsExpanded(false);
              }}>
        {styleText('Change Password')}
      </button>
      <a className="Profile-action"
         href="/support">
        {styleText('Support')}
      </a>
      <button className="Profile-action"
              onClick={() => logout({ returnTo: window.location.origin })}>
        {styleText('Logout')}
      </button>
    </div>
  }

  if (isLoading) {
    return <div>Loading ...</div>;
  }

  if (isAuthenticated) {
    const displayName = getDisplayName();

    return <>
      <StyledContainer className="Profile">
        {user?.picture && <img className="Profile-image" src={user.picture} alt={displayName} />}

        <Typography pl={1} variant="body1" className="Profile-nameAndRole">
          {displayName}{userData?.site_role && ` (${userData.site_role})`}
        </Typography>

        <button className="Profile-caret"
                style={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0)' }}
                onClick={() => setIsExpanded(curr => !curr)}>
          <CaretCircleDown />
        </button>

        {isExpanded && renderDropdown()}
      </StyledContainer>

      {userData?.site_role && (
        <EditUserModal
          user={userData}
          open={!!userData && isEditingProfile}
          roleName={userData.site_role}
          isProfilePage={true}
          onClose={() => setIsEditingProfile(false)}
        />
      )}

      {isAuthenticated && userData && (
        <ChangePasswordModal
          open={!!userData && isResettingPassword}
          onClose={() => setIsResettingPassword(false)}
        />
      )}
    </>;
  }

  return <div>Unexpected error.</div>;
};

export default Profile;

const StyledContainer = styled(Container)({
  marginRight: "20px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  width: "fit-content",
  position: "relative",

  '& .Profile-image': {
    height: "30px"
  },

  '& .Profile-nameAndRole': {
    color: "#231F20"
  },

  '& .Profile-caret': {
    appearance: 'none',
    border: 0,
    backgroundColor: 'unset',
    display: 'flex'
  },

  '& .Profile-dropdown': {
    position: 'absolute',
    width: '100%',
    top: 'calc(100% + 8px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    backgroundColor: 'white',
    border: '1px solid rgba(0, 0, 0, 0.3)',
    borderRadius: '5px',
    boxShadow: 'rgba(0, 0, 0, 0.3) 0px 1px 8px',
    overflow: 'hidden'
  },

  '& .Profile-action': {
    appearance: 'none',
    border: 0,
    backgroundColor: 'white',
    display: 'flex',
    width: '100%',
    padding: '8px 12px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)'
    }
  }
});